module.exports = __webpack_public_path__ + "fundo2.jpg?05a92ec6f6dc379bb96e298c54700799";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fundo2.jpg
// module id = 155
// module chunks = 0